
(function() {
  'use strict';

  var CONFIG = {
    buttonId: 'generate-pdf-btn',
    loadingId: 'pdf-loading',
    messageId: 'pdf-message',
    companyName: 'SIROCCO IMPEX SRL',
    companyAddress: 'Prieteniei 2 Cluj-Napoca 400399 - Romania',
    companyPhone: '+40 371 068 264',
    companyEmail: 'office@eurogastro.ro',
    pageHeight: 1109
  };

  var SCALE = 2;
  var PAGE_W = 794;
  var PAGE_H = CONFIG.pageHeight;

  // ─── Library wait ─────────────────────────────────────────────────────────────

  function waitForLibraries(callback) {
    var attempts = 0;
    function check() {
      if (++attempts > 50) return;
      if (typeof window.jsPDF !== 'undefined' && typeof window.html2canvas !== 'undefined') {
        callback();
      } else {
        setTimeout(check, 100);
      }
    }
    check();
  }

  function init() {
    var btn = document.getElementById(CONFIG.buttonId);
    if (!btn) return;
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      handleGeneratePDF();
    });
  }

  function handleGeneratePDF() {
    var btn     = document.getElementById(CONFIG.buttonId);
    var loading = document.getElementById(CONFIG.loadingId);
    var message = document.getElementById(CONFIG.messageId);
    if (loading) loading.style.display = 'block';
    if (btn)     btn.disabled = true;
    if (message) message.style.display = 'none';
    setTimeout(function() {
      try {
        if (!window.productData)                       throw new Error('Product data not found');
        if (typeof window.jsPDF === 'undefined')       throw new Error('jsPDF not loaded');
        if (typeof window.html2canvas === 'undefined') throw new Error('html2canvas not loaded');
        generatePDF(window.productData, btn, loading, message);
      } catch (err) {
        showError(message, btn, loading, err.message);
      }
    }, 100);
  }

  function showError(message, btn, loading, msg) {
    if (message) {
      message.innerHTML = '<div style="background:#f8d7da;color:#721c24;border:1px solid #f5c6cb;padding:12px;border-radius:4px;">Eroare: ' + msg + '</div>';
      message.style.display = 'block';
    }
    if (btn)     btn.disabled = false;
    if (loading) loading.style.display = 'none';
  }

  // ─── Data helpers ─────────────────────────────────────────────────────────────

  function safeStr(v) {
    if (v == null) return '';
    if (typeof v === 'string') return v;
    if (Array.isArray(v)) return v.join(', ');
    return String(v);
  }

  function escapeHtml(text) {
    var s = safeStr(text);
    return s.replace(/[&<>"']/g, function(c) {
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[c];
    });
  }

  function extractTextFromMetafield(jsonValue) {
    try {
      if (!jsonValue) return '';
      var raw = typeof jsonValue === 'string' ? jsonValue.trim() : null;
      if (raw && raw.startsWith('"') && raw.endsWith('"')) raw = raw.slice(1, -1);
      var data = raw ? JSON.parse(raw) : jsonValue;
      if (!data) return '';
      var parts = [];
      (function walk(n) {
        if (!n) return;
        if (n.type === 'text' && n.value) parts.push(n.value);
        if (n.children) n.children.forEach(walk);
      })(data);
      return parts.join('\n').trim();
    } catch (e) { return ''; }
  }

  /** Convert Shopify rich-text metafield JSON to HTML, preserving structure */
  function metafieldToHTML(jsonValue) {
    try {
      if (!jsonValue) return '';
      var raw = typeof jsonValue === 'string' ? jsonValue.trim() : null;
      if (raw && raw.startsWith('"') && raw.endsWith('"')) raw = raw.slice(1, -1);
      var data = raw ? JSON.parse(raw) : jsonValue;
      if (!data) return '';
      return renderNode(data);
    } catch (e) { return ''; }
  }

  function renderNode(node) {
    if (!node) return '';
    if (node.type === 'text') {
      var t = escapeHtml(node.value || '').replace(/\n/g, '<br>');
      if (node.bold)   t = '<strong>' + t + '</strong>';
      if (node.italic) t = '<em>' + t + '</em>';
      return t;
    }
    var inner = '';
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        inner += renderNode(node.children[i]);
      }
    }
    switch (node.type) {
      case 'root':       return inner;
      case 'paragraph':  return '<p>' + inner + '</p>';
      case 'heading':    var lvl = node.level || 3; return '<h' + lvl + '>' + inner + '</h' + lvl + '>';
      case 'list':       return node.listType === 'ordered' ? '<ol>' + inner + '</ol>' : '<ul>' + inner + '</ul>';
      case 'list-item':  return '<li>' + inner + '</li>';
      case 'link':       return '<a href="' + escapeHtml(node.url || '') + '">' + inner + '</a>';
      default:           return inner;
    }
  }

  // ─── HTML builders ────────────────────────────────────────────────────────────

  function buildHeaderHTML(shopLogo) {
    return (
      '<div style="display:flex;justify-content:space-between;align-items:center;padding:20px 25px 10px 25px;gap:20px;">' +
      '  <div style="flex:0 0 auto;max-width:180px;">' +
      (shopLogo ? '<img src="' + shopLogo + '" style="max-width:180px;height:auto;" />' : '') +
      '  </div>' +
      '  <div style="text-align:right;flex:1;">' +
      '    <h1 style="color:#e74c3c;font-size:26px;margin:0;">FIȘĂ TEHNICĂ</h1>' +
      '  </div>' +
      '</div>' +
      '<div style="background-color:#e74c3c;height:3px;width:100%;"></div>'
    );
  }

  function buildFooterHTML(pageNum, totalPages) {
    return (
      '<div style="padding:5px 25px 5px 25px;border-top:3px solid #e74c3c;background-color:white;' +
      'font-size:13px;font-family:Arial,sans-serif;">' +
      '  <div style="display:flex;justify-content:space-between;align-items:center;">' +
      '    <span>' + CONFIG.companyName + ' | ' + CONFIG.companyAddress + ' | ' + CONFIG.companyPhone + ' | ' + CONFIG.companyEmail + '</span>' +
      '    <span style="color:#000;">Pagina ' + pageNum + ' din ' + totalPages + '</span>' +
      '  </div>' +
      '</div>'
    );
  }

  function buildProductSectionHTML(data) {
    var html = '';
    html += '<h2 style="font-size:18px;margin:0 0 8px 0;font-weight:bold;line-height:1.3;">' + escapeHtml(data.title) + '</h2>';
    html += '<div style="display:flex;justify-content:space-between;gap:20px;margin-bottom:10px;">';
    html += '  <div style="flex:1;">';
    html += '    <div style="font-size:14px;text-transform:uppercase;color:#000;margin-bottom:6px;">';
    html += '      <strong style="color:#666;font-size:14px;text-transform:none;">Cod Produs:</strong> ' + escapeHtml(data.sku || 'N/A');
    html += '    </div>';
    html += '    <div><strong style="font-size:14px;color:#666;">Furnizor: </strong>';
    var prod = data.metafields && data.metafields.producator;
    if (prod && !prod.includes('http') && !prod.includes('.')) {
      html += '<div style="font-size:14px;text-transform:uppercase;color:#000;">' + escapeHtml(prod) + '</div>';
    } else {
      html += '<span style="font-size:16px;color:#000;">' + escapeHtml(data.vendor || '') + '</span>';
    }
    html += '    </div>';
    html += '  </div>';
    html += '  <div style="flex:0 0 auto;">';
    if (prod && (prod.includes('http') || prod.includes('.'))) {
      html += '<img src="' + prod + '" style="max-width:150px;max-height:70px;height:auto;" />';
    }
    html += '  </div>';
    html += '</div>';
    // Images row
    html += '<div style="display:flex;gap:15px;">';
    html += '  <div style="flex:0 0 auto;width:300px;">';
    if (data.images && data.images.length > 0) {
      html += '<img src="' + data.images[0].src + '"style="width:100%;height:100%;max-height:400px;object-fit:contain;" />';
    } else {
      html += '<div style="width:200px;height:200px;background:#f0f0f0;"></div>';
    }
    html += '  </div>';
    html += '  <div style="flex:1;display:flex;flex-direction:column;gap:8px;align-items:center;">';
    if (data.images && data.images.length > 1) {
      for (var i = 1; i < Math.min(3, data.images.length); i++) {
        html += '<img src="' + data.images[i].src + '" style="max-width:130px;height:auto;" />';
      }
    }
    var hasIcons = data.metafields && (data.metafields.icon_2 || data.metafields.icon_3 || data.metafields.made_in_logo);
    if (hasIcons) {
      html += '<div style="display:flex;gap:15px;">';
      if (data.metafields.made_in_logo) html += '<img src="' + data.metafields.made_in_logo + '" style="max-width:160px;max-height:100px;height:auto;" />';
      if (data.metafields.icon_2)       html += '<img src="' + data.metafields.icon_2       + '" style="max-width:160px;max-height:100px;height:auto;" />';
      if (data.metafields.icon_3)       html += '<img src="' + data.metafields.icon_3       + '" style="max-width:160px;max-height:100px;height:auto;" />';
      html += '</div>';
    }
    html += '  </div>';
    html += '</div>';
    return html;
  }

  function buildTextContentHTML(description, specs) {
    var css = (
      '<style>' +
      '  .product-description p { font-size: 14px; margin: 0 0 0px 0; color: #555; }' +
      '  .product-description h3 { font-size: 14px; }' +
      '  .product-description ul { font-size: 12px; list-style: disc !important; padding-left: 20px !important; }' +
      '  .product-description li { font-size: 12px; margin-top: 3px; }' +
      '  .product-description li::before { display: none !important; content: none !important; }' +
      '  .product-description li br { display: none !important; }' +
      '  .product-specs p  { font-size: 14px; margin: 0 0 0px 0; color: #555; }' +
      '  .product-specs ul { font-size: 14px; list-style: disc !important; padding-left: 20px !important; }' +
      '  .product-specs li { font-size: 14px; margin-top: 3px; }' +
      '  .product-specs li::before { display: none !important; content: none !important; }' +
      '</style>'
    );
  
    return (
      css +
      '<h3 style="color:#e74c3c;font-size:16px;margin:0 0 8px 0;font-weight:bold;">Descriere Produs</h3>' +
      '<div class="product-description" style="margin-bottom:15px;">' + description + '</div>' +
      '<h3 style="color:#e74c3c;font-size:16px;margin:0 0 8px 0;font-weight:bold;">Specificații Tehnice</h3>' +
      '<div class="product-specs" style="color: #555;font-size:14px;">' + specs + '</div>'
    );
  }

  // ─── Render helper ────────────────────────────────────────────────────────────

  async function renderToCanvas(h2c, htmlStr, extraCss) {
    var el = document.createElement('div');
    el.style.cssText = [
      'width:' + PAGE_W + 'px',
      'font-family:Arial,sans-serif',
      'background:white',
      'box-sizing:border-box',
      'position:absolute',
      'left:-30000px',
      'top:0',
      extraCss || ''
    ].join(';');
    el.innerHTML = htmlStr;
    document.body.appendChild(el);

    // Replace <li> with <div> so theme ::before styles have nothing to target
    var lis = el.querySelectorAll('li');
    for (var i = 0; i < lis.length; i++) {
      var li = lis[i];
      var div = document.createElement('div');
      div.innerHTML = li.innerHTML; // bullet + spacing
      div.style.cssText = 'margin-top:3px;font-size:inherit;color:inherit;';
      li.parentNode.replaceChild(div, li);
    }
    // Replace <ul>/<ol> with plain <div> to remove default list styling
    var lists = el.querySelectorAll('ul, ol');
    for (var j = 0; j < lists.length; j++) {
      var list = lists[j];
      var wrap = document.createElement('div');
      wrap.innerHTML = list.innerHTML;
      wrap.style.cssText = 'padding-left:10px;';
      list.parentNode.replaceChild(wrap, list);
    }

    var c = await h2c(el, {scale: SCALE, useCORS: true, logging: false, backgroundColor: '#ffffff', allowTaint: true});
    document.body.removeChild(el);
    return c;
  }

  function composePage(headerCanvas, productCanvas, textCanvas, footerCanvas,
                       headerH, productH, footerH,
                       textOffsetPx, sliceH, showProduct) {

    var out = document.createElement('canvas');
    out.width  = PAGE_W * SCALE;
    out.height = PAGE_H * SCALE;

    var ctx = out.getContext('2d');
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, out.width, out.height);

    // 1 ── Header
    ctx.drawImage(
      headerCanvas,
      0, 0, headerCanvas.width, headerCanvas.height,          // src
      0, 0, PAGE_W * SCALE, headerH * SCALE                   // dst
    );

    var curY = headerH; // element px

    // Extra top padding on continuation pages (2, 3, …)
    if (!showProduct) curY += 25;

    // 2 ── Product section (page 1 only)
    if (showProduct && productCanvas) {
      ctx.drawImage(
        productCanvas,
        0, 0, productCanvas.width, productCanvas.height,
        0, curY * SCALE, PAGE_W * SCALE, productH * SCALE
      );
      curY += productH;
    }

    // 3 ── Text slice — hard-clipped to [curY … PAGE_H-footerH-bottomPad]
    var bottomPad   = showProduct ? 0 : 25;       // extra bottom padding on pages 2+
    var footerTop   = PAGE_H - footerH - bottomPad; // element px
    var clipTop     = curY;                       // element px
    var clipHeight  = footerTop - clipTop;        // element px — available space

    if (clipHeight > 0) {
      // How many source pixels can we actually draw?
      var srcAvail = (textCanvas.height / SCALE) - textOffsetPx;
      var drawH    = Math.min(sliceH, clipHeight, srcAvail);

      if (drawH > 0) {
        ctx.save();
        // Clip rectangle: only draw inside the allocated text area
        ctx.beginPath();
        ctx.rect(0, clipTop * SCALE, PAGE_W * SCALE, clipHeight * SCALE);
        ctx.clip();

        ctx.drawImage(
          textCanvas,
          0,                textOffsetPx * SCALE,   // source origin (x, y)
          textCanvas.width, drawH * SCALE,           // source size   (w, h)
          0,                clipTop * SCALE,         // dest origin   (x, y)
          PAGE_W * SCALE,   drawH * SCALE            // dest size     (w, h)  — 1 : 1
        );

        ctx.restore();
      }
    }

    // 4 ── Footer — always pinned to the bottom of the page
    var actualFooterTop = PAGE_H - footerH;
    ctx.drawImage(
      footerCanvas,
      0, 0, footerCanvas.width, footerCanvas.height,
      0, actualFooterTop * SCALE, PAGE_W * SCALE, footerH * SCALE
    );

    return out;
  }

  // Safe page-break detection

  function findSafeBreakPoint(canvas, targetY, searchRange) {
    var ctx = canvas.getContext('2d');
    var canvasW = canvas.width;

    var scaledTarget = Math.min(Math.floor(targetY * SCALE), canvas.height - 1);
    var scaledRange  = Math.floor(searchRange * SCALE);
    var startY       = Math.max(0, scaledTarget - scaledRange);
    var blockHeight  = scaledTarget - startY;

    if (blockHeight <= 0) return targetY;

    var imageData = ctx.getImageData(0, startY, canvasW, blockHeight);
    var data      = imageData.data;
    var margin    = Math.floor(25 * SCALE); // skip left/right padding area

    // Scan from bottom (targetY) upward looking for a fully white row
    for (var row = blockHeight - 1; row >= 0; row--) {
      var isWhiteRow = true;
      var rowStart   = row * canvasW * 4;

      for (var x = margin; x < canvasW - margin; x += 4) {
        var idx = rowStart + x * 4;
        if (data[idx] < 250 || data[idx + 1] < 250 || data[idx + 2] < 250) {
          isWhiteRow = false;
          break;
        }
      }

      if (isWhiteRow) {
        return (startY + row) / SCALE;
      }
    }

    // No white row found — fall back to the original position
    return targetY;
  }

  // ─── Main ─────────────────────────────────────────────────────────────────────

  async function generatePDF(data, btn, loading, message) {
    try {
      var jsPDFCtor = window.jsPDF.jsPDF || window.jsPDF;
      var h2c       = window.html2canvas;
      var doc       = new jsPDFCtor({orientation: 'p', unit: 'mm', format: 'a4'});

      var specsJson   = (data.metafields && data.metafields.specificatii_tehnice) || null;
      var specs       = metafieldToHTML(specsJson) || 'Nu sunt disponibile.';
      var description = data.description || 'Nu sunt disponibile.';

      // ── Step 1: Render all content canvases ONCE ─────────────────────────────

      var headerCanvas  = await renderToCanvas(h2c, buildHeaderHTML(data.shopLogo), '');
      var headerH       = headerCanvas.height / SCALE;

      var productCanvas = await renderToCanvas(h2c, buildProductSectionHTML(data),
                            'padding:15px 25px;font-size:14px;line-height:1.4;color:#333;');
      var productH      = productCanvas.height / SCALE;

      // Text canvas: rendered once, sliced per page — this is the key to no repetition
      var textCanvas    = await renderToCanvas(h2c, buildTextContentHTML(description, specs),
                            'padding:25px 25px 15px 25px;font-size:12px;line-height:1.6;color:#555;');
      var textTotalH    = textCanvas.height / SCALE;

      // Measure footer height with a throwaway render (numbers don't change the height)
      var dummyFooter   = await renderToCanvas(h2c, buildFooterHTML(1, 1), '');
      var footerH       = dummyFooter.height / SCALE;

      // ── Step 2: Calculate page breaks (safe — never cuts through text) ─────

      var page1Avail = Math.max(0, PAGE_H - headerH - productH - footerH);
      var otherAvail = Math.max(0, PAGE_H - headerH - 25 - footerH - 25);

      var pageBreaks = []; // { offset, sliceH, showProduct }
      var textOffset = 0;
      var pageIdx    = 0;

      while (textOffset < textTotalH) {
        var isFirst   = (pageIdx === 0);
        var avail     = isFirst ? page1Avail : otherAvail;
        var remaining = textTotalH - textOffset;

        if (remaining <= avail) {
          // Everything left fits on this page
          pageBreaks.push({ offset: textOffset, sliceH: remaining, showProduct: isFirst });
          break;
        }

        // Find a white row near the ideal break so we don't cut through
        // text or images. Search up to 40% of the available space — enough
        // to skip over most images / table rows.
        var idealBreakY = textOffset + avail;
        var maxSearch    = Math.floor(avail * 0.4);
        var safeBreakY  = findSafeBreakPoint(textCanvas, idealBreakY, maxSearch);
        var sliceH      = safeBreakY - textOffset;

        // Guard against degenerate cases (no white row found nearby)
        if (sliceH < 50) sliceH = avail;

        pageBreaks.push({ offset: textOffset, sliceH: sliceH, showProduct: isFirst });
        textOffset += sliceH;
        pageIdx++;
      }

      var totalPages = pageBreaks.length;

      // ── Step 3: Pre-render all footers with correct page numbers ─────────────

      var footerCanvases = [];
      for (var f = 1; f <= totalPages; f++) {
        footerCanvases.push(
          await renderToCanvas(h2c, buildFooterHTML(f, totalPages), '')
        );
      }

      // ── Step 4: Compose and export pages ─────────────────────────────────────

      for (var p = 0; p < totalPages; p++) {
        var pb = pageBreaks[p];

        var pageCanvas = composePage(
          headerCanvas,
          pb.showProduct ? productCanvas : null,
          textCanvas,
          footerCanvases[p],
          headerH,
          pb.showProduct ? productH : 0,
          footerH,
          pb.offset,
          pb.sliceH,
          pb.showProduct
        );

        var imgData  = pageCanvas.toDataURL('image/png');
        var pdfH_mm  = (pageCanvas.height * 210) / pageCanvas.width;
        if (p === 0) {
          doc.addImage(imgData, 'PNG', 0, 0, 210, pdfH_mm);
        } else {
          doc.addPage();
          doc.addImage(imgData, 'PNG', 0, 0, 210, pdfH_mm);
        }
      }

      // ── Step 5: Save ──────────────────────────────────────────────────────────

      var filename = (data.title || 'document')
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9\-]/gi, '')
        .toLowerCase() + '-fisa-tehnica.pdf';

      window.pdfDownloadUrl = URL.createObjectURL(doc.output('blob'));
      window.pdfFilename    = filename;

      var filenameEl = document.getElementById('pdf-filename');
      if (filenameEl) filenameEl.textContent = filename;

      if (loading) loading.style.display = 'none';
      if (btn)     btn.style.display     = 'none';
      if (message) message.style.display = 'block';

    } catch (err) {
      console.error('PDF generation error:', err);
      showError(message, btn, loading, err.message);
    }
  }

  // ─── Boot ─────────────────────────────────────────────────────────────────────

  waitForLibraries(function() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  });

})();